import fetchClient from '../utils/fetchClient';

// Получить все избранные изображения пользователя
export const getUserBookmarks = async () => {
    const response = await fetchClient.get('/bookmarks/');
    return response;
};

// Получить конкретное избранное изображение по ID
export const getBookmarkById = async (bookmarkId) => {
    const response = await fetchClient.get(`/bookmarks/${bookmarkId}`);
    return response;
};

// Добавить изображение в избранное
export const addToBookmarks = async (imageRelationId) => {
    const response = await fetchClient.post('/bookmarks/', {
        image_relation_id: imageRelationId
    });
    return response;
};

// Удалить из избранного по ID
export const removeFromBookmarks = async (bookmarkId) => {
    const response = await fetchClient.delete(`/bookmarks/${bookmarkId}`);
    return response;
};

// Удалить из избранного по image_relation_id
export const removeFromBookmarksByImageRelation = async (imageRelationId) => {
    const response = await fetchClient.delete(`/bookmarks/by_image_relation/${imageRelationId}`);
    return response;
};

// Проверить, добавлено ли изображение в избранное
export const checkIfBookmarked = async (imageRelationId) => {
    const response = await fetchClient.get(`/bookmarks/check/${imageRelationId}`);
    return response;
}; 